import React, { useRef, useState } from 'react'
import { DateRangeType, DateType } from '../../../_config/types'
import DateRangePicker from '@wojtekmaj/react-daterange-picker'
import DatePicker from 'react-date-picker'

import 'react-date-picker/dist/DatePicker.css'
import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css'
import 'react-calendar/dist/Calendar.css'
import Icon from '../../icons'
import Label from './fromLabel'
import Error from './fromError'

type Value = DateType | DateRangeType

type DatepickerProps = {
    type?: 'range' | null
    value?: Value
    onChange?: (value: Value) => void
    minDate?: Date | undefined
    maxDate?: Date | undefined
    format?: string
    clearIcon?: React.ReactNode
    calendarIcon?: React.ReactNode
    error?: string
    className?: string
    disabled?: boolean
    required?: boolean
    info?: string
    label?: string
}

const Datepicker: React.FC<DatepickerProps> = ({ disabled = false, required, info, label, type = null, value, onChange, minDate = undefined, maxDate = undefined, format = 'd MM y', clearIcon = null, calendarIcon = null, error, className = '' }) => {
    //const [isOpen, setIsOpen] = useState<boolean>(false);


    return (
        <div className={`my-6 ${className}`}>
            {label && <Label text={label} required={required} info={info} />}

            <div className={`relative flex items-center min-w-[13.150rem] mt-2 rounded-[0.267rem] w-full ${className}`}>

                {type == 'range' ? (
                    <DateRangePicker
                        dayPlaceholder="DD"
                        monthPlaceholder="MM"
                        yearPlaceholder="YYYY"
                        value={value}
                        onChange={onChange}
                        onCalendarOpen={() => { }}
                        onCalendarClose={() => { }}
                        disabled={disabled}
                        minDate={minDate}
                        maxDate={maxDate}
                        format={format}
                        className={`rounded-[0.267rem] bg-white text-[0.667rem] pl-2 w-full border-0  h-[2.875rem] items-center ${error ? 'border-red-600 border-2' : 'border border-[#D4D4DA]'}`}
                        clearIcon={<Icon name='reset' size={1} />}
                        calendarIcon={<Icon name='calendar' size={1} />}
                        rangeDivider="~"
                    />
                ) : (
                    <DatePicker
                        value={value}
                        onChange={onChange}
                        onCalendarOpen={() => { }}
                        onCalendarClose={() => { }}
                        className={`rounded-[0.267rem] bg-white text-[0.667rem] px-2 w-full min-w-[4rem] h-[2.875rem] items-center text-start ${error ? 'border-red-500 border-2' : 'border border-[#D4D4DA]'}`}
                        minDate={minDate}
                        maxDate={maxDate}
                        format={format}
                        clearIcon={<Icon name='reset' size={1} />}
                        calendarIcon={<Icon name='calendar' size={1} />}
                    />
                )}
            </div>

            {error && <Error message={error} />}
        </div>


    )
}

export default Datepicker